var _defs, _path, _rect, _path2, _polygon, _rect2, _polygon2, _path3, _polygon3, _path4, _path5, _path6, _path7, _path8, _rect3, _path9, _polygon4, _rect4, _polygon5, _path10, _polygon6, _path11, _path12, _path13, _path14, _path15, _rect5, _path16, _polygon7, _rect6, _polygon8, _path17, _rect7, _path18, _path19, _path20, _path21, _path22, _polygon9, _path23, _polygon10, _rect8, _polygon11, _path24, _rect9, _path25, _path26, _path27, _path28, _path29, _polygon12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStockout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;}.cls-1{stroke:#1a242d;stroke-linecap:round;stroke-miterlimit:10;stroke-width:0.9px;}.cls-3,.cls-4{fill:#1d1d1b;}.cls-3{fill-rule:evenodd;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bruno") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20,12.86v8.57a.39.39,0,0,0,.4.39h1.49a.38.38,0,0,0,.39-.39l.06-9.94V9.12a1.33,1.33,0,0,0-.53-1.06l-.22-.16-5.94-4-1.52-1-.8-.52a2.39,2.39,0,0,0-2.64,0L1.91,8.15a.38.38,0,0,0-.15.29l-.06,13a.39.39,0,0,0,.39.39H4a.4.4,0,0,0,.4-.39l.05-8.38,0-2.69a.93.93,0,0,1,.93-.92H18.73A1.23,1.23,0,0,1,20,10.69l0,2.36"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 6.36,
    y: 16.84,
    width: 4.99,
    height: 4.99,
    rx: 1.38
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16.26,20.12H14.69l-1.55,3.67a3.3,3.3,0,0,0,.64.08h2.83A4.58,4.58,0,0,0,18,23.74Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "14.75 22.13 14.75 21.75 14.29 21.75 14.21 21.75 14.1 22.13 14.2 22.13 14.75 22.13"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 15.23,
    y: 21.75,
    width: 0.61,
    height: 0.38
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "16.97 22.12 16.84 21.75 16.31 21.75 16.32 22.13 16.97 22.12"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.69,20.12v-.73H10.94v.91a5,5,0,0,0,.13,1.57,2.83,2.83,0,0,0,2.07,1.92Z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "12.68 20.25 13.06 20.22 13.06 19.63 12.68 19.63 12.68 20.25"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M12.75,21.4l.35-.23a1.57,1.57,0,0,1,0-.53l-.38.12A2.29,2.29,0,0,0,12.75,21.4Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M13.59,22.1l.2-.36a.8.8,0,0,1-.47-.22l-.3.3A1,1,0,0,0,13.59,22.1Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.69,19.39v-.85l-1.75-3.62A2.89,2.89,0,0,0,11,17a8.22,8.22,0,0,0-.07,1.57v.82Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M12.94,16.93l.31.28a.84.84,0,0,1,.44-.27l-.22-.36A1.06,1.06,0,0,0,12.94,16.93Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M12.68,18l.38.1a3.11,3.11,0,0,1,0-.53l-.35-.21A4.49,4.49,0,0,0,12.68,18Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 12.68,
    y: 18.53,
    width: 0.38,
    height: 0.61
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.69,18.54h1.57l1.55-3.67a3.3,3.3,0,0,0-.64-.08H14.34a4.54,4.54,0,0,0-1.4.13Z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "16.2 16.54 16.2 16.91 16.66 16.91 16.74 16.91 16.85 16.54 16.75 16.54 16.2 16.54"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 15.12,
    y: 16.53,
    width: 0.61,
    height: 0.38
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "13.98 16.54 14.11 16.91 14.64 16.91 14.63 16.54 13.98 16.54"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16.26,18.54v.73H20v-.91a5.33,5.33,0,0,0-.12-1.57,2.86,2.86,0,0,0-2.08-1.92Z"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "18.27 18.41 17.9 18.44 17.9 19.03 18.27 19.03 18.27 18.41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M18.2,17.26l-.34.23a2.32,2.32,0,0,1,0,.53l.37-.12A2,2,0,0,0,18.2,17.26Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M17.37,16.56l-.2.36a.85.85,0,0,1,.47.22l.29-.3A1,1,0,0,0,17.37,16.56Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16.26,19.27v.85L18,23.74A2.85,2.85,0,0,0,20,21V19.27Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M18,21.73l-.31-.28a.8.8,0,0,1-.44.27l.22.36A1,1,0,0,0,18,21.73Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M18.27,20.64l-.37-.1a4.61,4.61,0,0,1,0,.53l.36.21A3.39,3.39,0,0,0,18.27,20.64Z"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 17.9,
    y: 19.52,
    width: 0.38,
    height: 0.61
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M9.42,13.87H7.85l-1.7,3.6a4.66,4.66,0,0,0,1.56.15H9.4a6.19,6.19,0,0,0,1.55-.1Z"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "7.81 15.88 7.81 15.5 7.29 15.5 7.16 15.88 7.81 15.88"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 8.29,
    y: 15.5,
    width: 0.6,
    height: 0.38
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "10 15.88 9.89 15.5 9.36 15.5 9.36 15.88 10 15.88"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M7.85,13.87V13H4.1v.81a6.78,6.78,0,0,0,.09,1.56,3,3,0,0,0,2,2.07Z"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 5.84,
    y: 13.27,
    width: 0.38,
    height: 0.6,
    transform: "translate(-0.03 0.01) rotate(-0.13)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M5.9,15l.35-.21a1.82,1.82,0,0,1,0-.52l-.38.09A2.28,2.28,0,0,0,5.9,15Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M6.66,15.81l.21-.35a1.13,1.13,0,0,1-.43-.29l-.3.28A1.25,1.25,0,0,0,6.66,15.81Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M7.85,13v-.74L6.32,8.64a3,3,0,0,0-2.08,2,4.94,4.94,0,0,0-.14,1.56V13Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M6.21,10.63l.29.3A1,1,0,0,1,7,10.68l-.2-.35A1.24,1.24,0,0,0,6.21,10.63Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M5.84,11.67l.38.12a1.16,1.16,0,0,1,.06-.52l-.35-.22A1.64,1.64,0,0,0,5.84,11.67Z"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "5.84 12.79 6.21 12.79 6.21 12.2 5.84 12.18 5.84 12.79"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M7.85,12.29H9.42l1.7-3.6a4.66,4.66,0,0,0-1.56-.15H7.87a6.19,6.19,0,0,0-1.55.1Z"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "9.46 10.29 9.46 10.66 9.98 10.66 10.11 10.29 9.46 10.29"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 8.38,
    y: 10.29,
    width: 0.6,
    height: 0.38
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "7.27 10.29 7.38 10.66 7.91 10.66 7.91 10.29 7.27 10.29"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M9.42,12.29v.84h3.75v-.81a6.67,6.67,0,0,0-.09-1.55,3,3,0,0,0-2-2.08Z"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 11.06,
    y: 12.29,
    width: 0.38,
    height: 0.6,
    transform: "translate(-0.03 0.03) rotate(-0.13)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M11.37,11.15l-.35.21a2.2,2.2,0,0,1,0,.52l.37-.1A1.9,1.9,0,0,0,11.37,11.15Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M10.61,10.36l-.21.35a1,1,0,0,1,.43.28l.3-.28A1.23,1.23,0,0,0,10.61,10.36Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M9.42,13.13v.74L11,17.52a3,3,0,0,0,2.22-2.87V13.13Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M11.06,15.53l-.29-.3a1,1,0,0,1-.46.25l.2.36A1.21,1.21,0,0,0,11.06,15.53Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M11.43,14.49l-.37-.12a1.29,1.29,0,0,1-.07.52l.35.22A1.61,1.61,0,0,0,11.43,14.49Z"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "11.43 13.38 11.06 13.38 11.06 13.96 11.43 13.98 11.43 13.38"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStockout);
export default __webpack_public_path__ + "static/media/stockout.929b8e73eabd231e4b1a6ee8363fe4cd.svg";
export { ForwardRef as ReactComponent };